import { BikeleasingContractListItemDTOStatusEnum } from '../api';

export function getBikeleasingContractStatusColor(status?: BikeleasingContractListItemDTOStatusEnum) {
  switch (status) {
    case BikeleasingContractListItemDTOStatusEnum.Active:
      return 'success';
    case BikeleasingContractListItemDTOStatusEnum.Expiring:
    case BikeleasingContractListItemDTOStatusEnum.EmployerApprovalRequired:
    case BikeleasingContractListItemDTOStatusEnum.EmployerApprovalDone:
      return 'warning';
    case BikeleasingContractListItemDTOStatusEnum.BikeShipped:
    case BikeleasingContractListItemDTOStatusEnum.BikeTransferDone:
    case BikeleasingContractListItemDTOStatusEnum.BikeTransferRequired:
    case BikeleasingContractListItemDTOStatusEnum.EmployeeApprovalRequired:
    case BikeleasingContractListItemDTOStatusEnum.Requested:
      return 'info';
    case BikeleasingContractListItemDTOStatusEnum.Finished:
      return 'default';
    case BikeleasingContractListItemDTOStatusEnum.CancelledOrRejected:
    default:
      return 'error';
  }
}
